import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import resortsApi from '~/api/resortsApi';
import weatherApi from '~/api/weatherApi';
import { WEATHER_STATIONS } from '~/config/settings/settingsWeatherStations';

/**
 *
 */
export const state = () => ({
    resortData: null,
    resortDataError: false,
    weatherStationData: null,
    weatherStationDataError: false,
    isDataReady: false,
});

export const mutations = {
    setResortData(state, payload) {
        state.resortData = payload;
    },

    setWeatherStationData(state, payload) {
        state.weatherStationData = payload;
    },

    setIsDataReady(state, flag) {
        state.isDataReady = flag;
    },

    setResortDataError(state, payload) {
        state.resortDataError = payload;
    },

    setWeatherStationDataError(state, payload) {
        state.weatherStationDataError = payload;
    },

    setEachLiftStatus(state, status) {
        const lifts = cloneDeep(state.resortData.lifts);
        lifts.forEach((lift) => {
            lift.status = status;
        });
        state.resortData.lifts = lifts;
    },

    setEachTrackStatus(state, status) {
        const tracks = cloneDeep(state.resortData.tracks);
        tracks.forEach((track) => {
            track.status = status;
        });
        state.resortData.tracks = tracks;
    },
};

export const actions = {
    async loadResortData({ commit }) {
        const resortData = await resortsApi.loadResortData();
        if (!resortData.error) {
            commit('setResortData', resortData.data);
            commit('setResortDataError', false);
        } else {
            commit('setResortDataError', resortData.error);
        }
    },

    async loadWeatherStationData({ commit }) {
        const weatherStationData = await weatherApi.loadWeatherStationData();
        if (!weatherStationData.error) {
            commit('setWeatherStationData', weatherStationData.data);
            commit('setWeatherStationDataError', false);
        } else {
            commit('setWeatherStationDataError', weatherStationData.error);
        }
    },
};

export const getters = {
    currentResort(state, otherGetters, rootState) {
        return get(state, 'resortData.resorts', {})[rootState.currentResortId];
    },

    webcams(state, otherGetters) {
        return get(otherGetters.currentResort, 'webcams', []);
    },

    messages(state, otherGetters) {
        return get(otherGetters.currentResort, 'messages', []);
    },

    resortName(state, otherGetters) {
        return get(otherGetters.currentResort, 'resort.name', '');
    },

    elevationValley(state, otherGetters) {
        return get(otherGetters.currentResort, 'resort.valley.elevation', '0');
    },

    elevationPeak(state, otherGetters) {
        return get(otherGetters.currentResort, 'resort.peak.elevation', '0');
    },

    avalancheRisk(state, otherGetters) {
        return get(otherGetters.currentResort, 'summary.avalancheRisk.level', '0');
    },

    snowNew(state, otherGetters) {
        return get(otherGetters.currentResort, 'summary.peakSnow.last24hInCm', '0');
    },

    snowMountains(state, otherGetters) {
        return get(otherGetters.currentResort, 'summary.peakSnow.heightInCm', '0');
    },

    snowValley(state, otherGetters) {
        return get(otherGetters.currentResort, 'summary.valleySnow.heightInCm', '0');
    },

    snowQuality(state, otherGetters) {
        return get(otherGetters.currentResort, 'summary.peakSnow.condition', '');
    },

    liftsTotal(state, otherGetters) {
        return get(otherGetters.currentResort, 'summary.lifts.total', '0');
    },

    liftsOpen(state, otherGetters) {
        return get(otherGetters.currentResort, 'summary.lifts.open', '0');
    },

    pistesTotal(state, otherGetters) {
        return Math.floor(get(otherGetters.currentResort, 'summary.pistes.metersTotal', 0) / 1000);
    },

    pistesOpen(state, otherGetters) {
        return Math.floor(get(otherGetters.currentResort, 'summary.pistes.metersOpen', 0) / 1000);
    },

    hasImportantMessage(state, otherGetters, rootState) {
        return otherGetters.messages && otherGetters.messages.length > 0;
    },

    weatherStations(state, otherGetters, rootState) {
        return state.weatherStationData.filter(station => rootState.currentResortId && (WEATHER_STATIONS[rootState.currentResortId] || []).includes(station.location.id));
    },
};
